import React, { useState } from "react";
import { auth, db } from "../firebase";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, getDocs, collection } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";

function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [state, setState] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handlePasswordReset = async () => {
  const email = prompt("Enter your email address to receive a password reset link:");
  if (!email) return;

  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent! Check your inbox.");
  } catch (error) {
    console.error("Password reset error:", error);
    alert("There was a problem sending the reset email. Please check the email address.");
  }
};



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");


  if (!isLogin && username.trim().toLowerCase() === "admin") {
    setError("Please select another username.");
    return;
  }

    if (!isLogin && (!username || !state)) {
      setError("Username and State are required.");
      return;
    }

    try {
  if (isLogin) {
    await signInWithEmailAndPassword(auth, email, password);
    navigate("/");
  } else {
    const usersRef = collection(db, "users");
    const existingUsers = await getDocs(usersRef);
    const usernameTaken = existingUsers.docs.some(
      (doc) => doc.data().username?.toLowerCase() === username.toLowerCase()
    );

    if (usernameTaken) {
      setError("That username is already in use. Please choose another.");
      return;
    }

    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    await setDoc(doc(db, "users", user.uid), {
      uid: user.uid,
      email,
      username,
      state,
    });

    navigate("/");
  }
} catch (err) {
  console.error("Login error code:", err.code);

  if (err.code === "auth/user-not-found") {
    setError("Email not recognized. Please check and try again.");
  } else if (err.code === "auth/wrong-password" || err.code === "auth/invalid-credential") {
    setError("Incorrect email or password. Please try again.");
  } else if (err.code === "auth/invalid-email") {
    setError("Invalid email format.");
  } else if (err.code === "auth/too-many-requests") {
    setError("Too many login attempts. Please wait and try again later.");
  } else if (err.code === "auth/missing-password") {
  setError("Please enter your password.");
  } else {
    setError(`Login failed: ${err.code}`);
  }
}}

             
 return (
  <>
    <div style={{ position: "relative", minHeight: "200px", padding: "20px" }}>
      {/* Faint background logo */}
        <div
  style={{
    backgroundImage: 'url("/vibescan-logo.png")',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain", // or "cover" for full coverage
    position: "absolute", // <-- key change
    top: 0,
    left: 0,
    right: 10,
    bottom: -200,
    opacity: 0.1, // softer overlay
    zIndex: -1, // <-- key change to push it behind
    pointerEvents: "none", // keeps it non-interactive
  }}
/>


      {/* Foreground content */}
      <div style={{ position: "relative", zIndex: 1 }}>
        <div
          style={{
            backgroundColor: "none",
            padding: "5px",
            borderRadius: "6px",
            marginBottom: "5px",
            fontSize: "14px",
            border: "none",
            maxWidth: "800px",
          }}
        >
	<li style={{ marginBottom: "10px" }}>✅ We do not collect any personal information. All we ask for is an email. Beyond that, you choose what to share.</li>
	<li style={{ marginBottom: "2px" }}>✅ If you do not want to be anonymous, use your name as user name during registration.</li>
        </div>

        <div style={{ maxWidth: "400px", margin: "auto", padding: "0px", textAlign: "left" }}>
          <h2>{isLogin ? "Login" : "Register"}</h2>
          {error && <p style={{ color: "red" }}>{error}</p>}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ border: "none", borderBottom: "2px solid #ccc", outline: "none", padding: "8px", marginBottom: "10px" }}
            />

            {!isLogin && (
              <>
                <label>Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  style={{ border: "none", borderBottom: "2px solid #ccc", outline: "none", padding: "8px", marginBottom: "10px" }}
                />

                <label>State</label>
              <select
  value={state}
  onChange={(e) => setState(e.target.value)}
  required
  style={{ border: "none", borderBottom: "2px solid #ccc", outline: "none", padding: "8px", marginBottom: "10px" }}
>
  <option value="">Select a State</option>
  <option value="AL">Alabama</option>
  <option value="AK">Alaska</option>
  <option value="AZ">Arizona</option>
  <option value="AR">Arkansas</option>
  <option value="CA">California</option>
  <option value="CO">Colorado</option>
  <option value="CT">Connecticut</option>
  <option value="DE">Delaware</option>
  <option value="FL">Florida</option>
  <option value="GA">Georgia</option>
  <option value="HI">Hawaii</option>
  <option value="ID">Idaho</option>
  <option value="IL">Illinois</option>
  <option value="IN">Indiana</option>
  <option value="IA">Iowa</option>
  <option value="KS">Kansas</option>
  <option value="KY">Kentucky</option>
  <option value="LA">Louisiana</option>
  <option value="ME">Maine</option>
  <option value="MD">Maryland</option>
  <option value="MA">Massachusetts</option>
  <option value="MI">Michigan</option>
  <option value="MN">Minnesota</option>
  <option value="MS">Mississippi</option>
  <option value="MO">Missouri</option>
  <option value="MT">Montana</option>
  <option value="NE">Nebraska</option>
  <option value="NV">Nevada</option>
  <option value="NH">New Hampshire</option>
  <option value="NJ">New Jersey</option>
  <option value="NM">New Mexico</option>
  <option value="NY">New York</option>
  <option value="NC">North Carolina</option>
  <option value="ND">North Dakota</option>
  <option value="OH">Ohio</option>
  <option value="OK">Oklahoma</option>
  <option value="OR">Oregon</option>
  <option value="PA">Pennsylvania</option>
  <option value="RI">Rhode Island</option>
  <option value="SC">South Carolina</option>
  <option value="SD">South Dakota</option>
  <option value="TN">Tennessee</option>
  <option value="TX">Texas</option>
  <option value="UT">Utah</option>
  <option value="VT">Vermont</option>
  <option value="VA">Virginia</option>
  <option value="WA">Washington</option>
  <option value="WV">West Virginia</option>
  <option value="WI">Wisconsin</option>
  <option value="WY">Wyoming</option>
  <option value="Outside US">Outside US</option>

</select>

              </>
            )}

            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ border: "none", borderBottom: "2px solid #ccc", outline: "none", padding: "8px", marginBottom: "10px" }}
            />

            <button
              type="submit"
              style={{
                padding: "10px",
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                cursor: "pointer",
                marginTop: "10px",
              }}
            >
              {isLogin ? "Login" : "Register"}
            </button>
          </form>

          <p style={{ marginTop: "10px", textAlign: "center" }}>
            {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
            <span
              onClick={() => setIsLogin(!isLogin)}
              style={{ color: "#007BFF", cursor: "pointer", textDecoration: "underline" }}
            >
              {isLogin ? "Register here" : "Login here"}
            </span>

	<p style={{ marginTop: "10px" }}>
  <button
    onClick={handlePasswordReset}
    style={{
      background: "none",
      border: "none",
      color: "#007BFF",
      cursor: "pointer",
      textDecoration: "underline",
      padding: 0
    }}
  >
    Forgot your password?
  </button>
</p>



          </p>
        </div>
      </div>
    </div>
  </>
);
}

export default AuthPage;
